import { REFERENCE_SCALE_PX_PER_MM } from '@/constants/canvas';

/** Longueur par défaut des lignes / mesures (échelle monde = pipeline bitmap). */
export const ANNOTATION_DEFAULT_LINE_LENGTH_MM = 1000;

/** Cercle par défaut : diamètre 1000 mm (même ordre de grandeur qu’une ligne). */
export const ANNOTATION_DEFAULT_CIRCLE_DIAMETER_MM = 1000;

export const ANNOTATION_DEFAULT_RECT_WIDTH_MM = 1000;
export const ANNOTATION_DEFAULT_RECT_HEIGHT_MM = 800;

/** Épaisseur de trait par défaut (unités canvas, curseur édition 5–50). */
export const ANNOTATION_DEFAULT_STROKE_PX = 20;

/** Poignées : rayon / trait en pixels écran (comme BlockInstance, ÷ canvasPixelsPerUser). */
export const ANNOTATION_HANDLE_RADIUS_PX = 16;
export const ANNOTATION_HANDLE_STROKE_PX = 2.5;

export const ANNOTATION_CIRCLE_GUIDE_STROKE_PX = 2;
export const ANNOTATION_MEASURE_ARROW_PX = 28;

/** Taille du texte de l’étiquette « mesure » (pixels écran, ÷ canvasPixelsPerUser). */
export const ANNOTATION_MEASURE_LABEL_FONT_PX = 14;

export function annotationMmToCanvasPx(mm: number): number {
  return mm * REFERENCE_SCALE_PX_PER_MM;
}
